module.exports = __webpack_public_path__ + "static/media/mira-technology-park.e4c304c8.jpg";